import { makeObservable } from 'mobx';
import SideMenuStore from '../components/SideMenu/SideMenuStore';
import AcknowledgmentsStore from '../pages/Acknowledgments/AcknowledgmentsStore';
import AuditStore from '../pages/Audit/AuditStore';
import CheckQualificationsStore from '../pages/CheckQualifications/CheckQualificationsStore';
import ConfirmationStore from '../pages/Confirmation-Summary/ConfirmationStore';
import DashboardStore from '../pages/Dashboard/DashboardStore';
import VerificationCodeModalContentStore from '../pages/Dashboard/VerificationCodeModalContentStore';
import PracticeUserManagementStore from '../pages/PracticeUserManagement/PracticeUserManagementStore';
import RoleManagementStore from '../pages/RolesManagement/RoleManagementStore';
import RolesManagementStore from '../pages/RolesManagement/RolesManagementStore';
import ScheduleUpgradeStore from '../pages/ScheduleUpgrade/ScheduleUpgradeStore';
import ServiceEventsStore from '../pages/ServiceEvents/ServiceEventsStore';
import UpdateUpgradeVersionsStore from '../pages/UpgradeManagement/UpdateUpgradeVersionsStore';
import UpgradeManagementStore from '../pages/UpgradeManagement/UpgradeManagementStore';
import UpgradeVersionManagementStore from '../pages/UpgradeVersionManagement/UpgradeVersionManagementStore';
import AddUsersStore from '../pages/UsersManagement/AddUsersStore';
import { UsersManagementStore } from '../pages/UsersManagement/UsersManagementStore';
import AbstractStore from './AbstractStore';
import ApiStore from './ApiStore';
import GlobalStore from './GlobalStore';

export default class RootStore {
  public readonly globalStore = new GlobalStore(this);
  public readonly apiStore = new ApiStore(this);
  public readonly dashboardStore = new DashboardStore(this);
  public readonly scheduleUpgradeStore = new ScheduleUpgradeStore(this);
  public readonly checkQualificationsStore = new CheckQualificationsStore(this);
  public readonly confirmationStore = new ConfirmationStore(this);
  public readonly rolesManagementStore = new RolesManagementStore(this);
  public readonly usersManagementStore = new UsersManagementStore(this);
  public readonly roleManagementStore = new RoleManagementStore(this);
  public readonly sideMenuStore = new SideMenuStore(this);
  public readonly auditStore = new AuditStore(this);
  public readonly practiceUserManagementStore = new PracticeUserManagementStore(this);
  public readonly serviceEventsStore = new ServiceEventsStore(this);
  public readonly verificationCodeModalContentStore = new VerificationCodeModalContentStore(this);
  public readonly upgradeManagementStore = new UpgradeManagementStore(this);
  public readonly manageUpgradeVersionsStore = new UpdateUpgradeVersionsStore(this);
  public readonly acknowledgmentsStore = new AcknowledgmentsStore(this);
  public readonly addUsersStore = new AddUsersStore(this);
  public readonly upgradeVersionManagementStore = new UpgradeVersionManagementStore(this);

  constructor() {
    Object.keys(this).forEach(storeName => {
      const store = this[storeName];
      if (!(store instanceof AbstractStore))
        throw new Error(`${storeName} is not an instance of AbstractStore subclass`);
      makeObservable(store);
    });
  }

  // no methods allowed in this class because they will be anyway unavailable in useStore() hook result
}
